import { ol_Feature } from "@omnia/exports/openlayers"

export class BoundaryDrawingLayer extends omnia.map.Layer {


    private _feature: ol_Feature
    private _opacity: number = 50

    constructor(private _sourceLayer: omnia.map.Layer) {
        super()
    }

    get opacity() {
        return this._opacity
    }

    set opacity(value) {
        this._opacity = value
        this.refreshTargetFeature()
    }

    createTargetFeatureFromSource(feature: ol_Feature): any {

        let geom = <any>(feature.getGeometry());
        if (!geom) return null;

        var targetFeature = new ol_Feature({

            geometry: geom.clone(),

        });


        targetFeature.set("data", feature.get("data"));
        targetFeature.set("layer", this);

        this._feature = targetFeature;

        this.refreshTargetFeature();

        this._source.addFeatures([targetFeature]);

        return targetFeature;

    }

    setupNewTargetFeature(feature: any, add: boolean): any {

        if (add) {
            this._source.addFeatures([feature]);
        }

        this._feature = feature;

        this.refreshTargetFeature();

        return feature;

    }


    refreshTargetFeature() {

        if (this._feature) {

            const alpha = (this.opacity / 100)
            const styleFunction = omnia.map.styles.getDefaultEditStyleFunction(this._feature, [255, 255, 255, alpha], true)

            const f = <any>this._feature
            f.setStyle(styleFunction)

        }

    }

}
